import { Controller } from "stimulus"
import { Rails } from "../shared/shared"

export default class extends Controller {
  static targets = ['form']

  connect () {
    this.formTarget.scrollIntoView({ behavior: "smooth" });
  }
}